import { disableBodyScroll, enableBodyScroll, NAV_BREAKPOINT, ResizeThrottler } from './utils';

const { TweenMax, $ } = window;
const resizeThrottler = new ResizeThrottler();
// const NAV_HEIGHT = 70;
// const OPEN_NAV_HEIGHT = 180;

function desktopWidth() {
  return $(document).width() > NAV_BREAKPOINT;
}

// Set full height for tertiary nav dropdowns

let fullTertiaryHeightSet = false;
function setFullTertiaryHeight() {
  if (fullTertiaryHeightSet) {
    // We're done our job, stop listening
    resizeThrottler.remove(setFullTertiaryHeight);
  } else if (desktopWidth()) {
    // Set out full height
    [...document.querySelectorAll('.nav-drop__tertiary:not(:empty)')].forEach((el) => {
      el.style.maxHeight = 'none';
      el.style.setProperty('--full-height', el.offsetHeight + 'px');
      el.style.maxHeight = '0';
      fullTertiaryHeightSet = true;
    });
  }
}
setFullTertiaryHeight();
resizeThrottler.add(setFullTertiaryHeight);

// Show and hide top banner

const topBanner = $('.top-banner');
const topBannerId = topBanner.attr('id');
let topBannerHeight;
let displayTopBanner = true;

function positionTopBanner() {
  topBannerHeight = topBanner.height();
  topBanner.css('top', -1 * topBannerHeight);
  topBanner.animate({ top: 0 }, 'slow');
  $('.nav-bar, .hidden-nav-gradient').animate({ top: topBannerHeight }, 'slow');
  $('body').animate({ 'margin-top': topBannerHeight }, 'slow');
}

function repositionTopBanner() {
  topBannerHeight = topBanner.height();
  $('.nav-bar, .hidden-nav-gradient').css('top', topBannerHeight);
  $('body').css('margin-top', topBannerHeight);
}

function closeTopBanner() {
  displayTopBanner = false;
  $('.nav-bar, .hidden-nav-gradient').animate({ top: 0 }, 'slow');
  $('body').animate({ 'margin-top': 0 }, 'slow');
  topBanner.animate({ top: -1 * topBannerHeight }, 'slow');
  setTimeout(() => {
    topBanner.css('display', 'none');
  }, 600);
  localStorage.setItem(topBannerId, true);
}

if (topBanner.length && !localStorage.getItem(topBannerId)) {
  positionTopBanner();
  $('#js-close-top-banner').on('click', closeTopBanner);
} else {
  displayTopBanner = false;
}

let searchBoxTimeline;

function openNav() {
  if (desktopWidth()) {
    if ($('.top-banner').css('display') === 'none') {
      TweenMax.set('.nav-bar', { clearProps: 'top' });
    } else {
      TweenMax.set('.nav-bar', { top: topBannerHeight || 0 });
    }
  }
}

function closeNav() {
  $('.nav-bar').removeClass('nav-bar--active');
}

$(window).resize(() => {
  const ww = $(window).width();
  resetAnimations();
  if (ww >= mobileBreakpoint) {
    enableBodyScroll();
  }
  if (topBanner.length && displayTopBanner) repositionTopBanner();
  if (ww >= NAV_BREAKPOINT) {
    $('body, .nav-bar').removeClass('mobile-nav-open');
  }
});

function resetAnimations() {
  if ($('.search-box').data('open')) {
    const dropdown = $('.command-panel__drop');
    const dropdownWidth = dropdown.innerWidth();
    const searchForm = $('form.search-box');
    const searchBox = searchForm.parent('.nav-icons__icon');
    const searchInput = $('.search-box__input');
    const nonSearchIcons = $('.nav-icons__icon').slice(1);
    const reverseTimeLine = new TimelineLite();
    reverseTimeLine.set([searchBox, searchInput, dropdown, '.search-box__icon', '.search-box', '.nav-icons', '.search-box__label', '.nav-icon-wrapper', '.nav-icon', '.close-search'], { clearProps: 'all' });
    $('.search-box').data('open', false);
  }
}

function toggleMobileNav() {
  $('.nav-drop__primary, .nav-drop__secondary, .nav-drop__tertiary').removeClass('nav-drop--open');
  if ($('.nav-bar').hasClass('mobile-nav-open')) {
    $('.nav-bar').removeClass('mobile-nav-open');
    enableBodyScroll();
  } else {
    $('.nav-bar').addClass('mobile-nav-open');
    disableBodyScroll();
  }
}

$('#activate-mobile-nav').click(toggleMobileNav);

// if you click a link in the mobile nav that takes you to another hash location on the same page, close the nav and go there

$('a.nav-underline').on('click', function(e) {
  if ($(window).width() <= NAV_BREAKPOINT // is mobile
      && $('.nav-bar').hasClass('mobile-nav-open') // mobile nav is open
      && this.href.indexOf('#') > 1 // is a hash link
      && $(this.href.split('/')).last()[0].replace(/#.*/, '') == $(window.location.href.split('/')).last()[0].replace(/#.*/, '')) // destination is the current page
  {
    toggleMobileNav();
    window.location.href = this.href;
  }
});

// Toggle secondary nav menus on mobile

[...document.querySelectorAll('.nav-drop__item--primary')].forEach((el) => {
  const secondaryList = el.querySelector('.nav-drop__secondary');
  if (secondaryList) {
    el.addEventListener('click', (e) => {
      if (!desktopWidth()) {
        if (!secondaryList.classList.contains('nav-drop--open')) {
          // prevent navigation so we can open the dropdown
          e.preventDefault();
        }
        // close the other lists and open this one
        [...document.querySelectorAll('.nav-drop__secondary')].forEach((list) => {
          list.classList.remove('nav-drop--open');
        });
        secondaryList.classList.add('nav-drop--open');
      }
    });

    // Toggle tertiary nav menus on mobile

    [...secondaryList.querySelectorAll('.nav-drop__item--secondary')].forEach((secondaryListItem) => {
      const tertiaryList = secondaryListItem.querySelector('.nav-tertiary');
      if (tertiaryList) {
        secondaryListItem.querySelector('.nav-icon-row').addEventListener('click', (e) => {
          if (!desktopWidth()) {
            if (!tertiaryList.classList.contains('nav-tertiary--open')) {
              // prevent navigation so we can open the dropdown
              e.preventDefault();
            }
            // close the other lists and open this one
            [...document.querySelectorAll('.nav-tertiary')].forEach((list) => {
              list.classList.remove('nav-tertiary--open');
            });
            tertiaryList.classList.add('nav-tertiary--open');
            [...secondaryList.querySelectorAll('.nav-drop__item--secondary')].forEach((otherList) => {
              otherList.style.height = 'auto';
            });
            const height = (secondaryListItem.offsetHeight + tertiaryList.offsetHeight) + 'px';
            secondaryListItem.style.height = height;
          }
        });
      }
    });
  }
});

function desktopSearchAnimation() {
  // console.info('trigger Deskstop search anim')
  const dropdown = $('.command-panel__drop');
  const searchBox = $('.search-box__input');
  const searchForm = $('form.search-box')
    .addClass('search-box--open');
  const iconsHeight = $('.nav-icons').height();
  const labelHeight = $('.search-box__label').innerHeight();
  const searchIconRight = $('.search-box__icon').css('right');
  const dropdownWidth = dropdown.innerWidth();
  $('.nav-drop').removeClass('nav-drop--active');
  closeNav();
  $('.search-box').data('open', true);
  searchBoxTimeline = new TimelineLite({ paused: true });
  searchBoxTimeline.add('start', 0);
  searchBoxTimeline.add('widenBox', 0.25);
  searchBoxTimeline.add('heightenBox', 1.25);

  const logoSearchBuffer = 150;
  const searchBoxWidth = $('.nav').width() - $('.nav__logo').width() - logoSearchBuffer;
  $('.nav-icons').height(iconsHeight);

  // Squash label with the search icon, lock height of the form, fade in form border
  searchBoxTimeline.to('.search-box__label', 0.25, { height: 0 }, 'start');
  searchBoxTimeline.to('.search-box__icon', 0.25, { y: labelHeight / 2 }, 'start');
  searchBoxTimeline.to(searchBox, 0.25, { height: iconsHeight }, 'start');
  searchBoxTimeline.to('.search-box', 0.25, { borderWidth: 1, borderColor: 'rgba(255,255,255,1)' }, 'start');
  searchBoxTimeline.to('.command-panel__icons', 0.25, { borderWidth: 0 }, 'start');

  // Spread out the search box as we simultaneously wipe the dropdown
  searchBoxTimeline.to(searchBox, 1, { width: searchBoxWidth }, 'widenBox');
  searchBoxTimeline.to('.search-box__icon', 0.2, { right: 12 }, 'widenBox');
  searchBoxTimeline.to('.search-box', 0.25, { paddingLeft: 10, paddingRight: 0 }, 'widenBox');
  searchBoxTimeline.to(dropdown, 1, { width: 0 }, 'widenBox');
  searchBoxTimeline.to(dropdown, 1.5, { borderColor: 'rgba(255,255,255,0)' }, 'widenBox');

  const closeSearchTimeLine = new TimelineLite();
  const nonSearchIcons = $('.nav-icons__icon').slice(1);
  closeSearchTimeLine.to(nonSearchIcons, 0.25, { autoAlpha: 0 });
  closeSearchTimeLine.to('.close-search', 0.25, { autoAlpha: 1 });
  searchBoxTimeline.add(closeSearchTimeLine, 'start');

  // Fade in the placeholder text
  searchBoxTimeline.to(searchBox, 1, { opacity: 1 }, 'heightenBox');
  searchBoxTimeline.play();
  searchBox.focus();
}

function mobileSearchAnimation() {
  // console.info("trigger Mobile search anim")
  const dropdown = $('.command-panel__drop');
  const dropdownWidth = dropdown.innerWidth();
  const searchForm = $('form.search-box')
    .addClass('search-box--open');
  const searchBox = searchForm.parent('.nav-icons__icon');
  const searchInput = $('.search-box__input');
  const nonSearchIcons = $('.nav-icons__icon').slice(1);
  searchBoxTimeline = new TimelineLite({ paused: true });
  $('.search-box').data('open', true);
  const duration = 1;
  searchBoxTimeline.add('fadeOut', 0);
  searchBoxTimeline.add('widenBox', 0.25);
  searchBoxTimeline.to(nonSearchIcons, 0.25, { autoAlpha: 0, display: 'none' }, 'fadeOut');
  searchBoxTimeline.to('.search-box__label', 0.25, { height: 0 }, 'fadeOut');
  searchBoxTimeline.to(searchBox, duration, { width: (dropdownWidth - 38) }, 'widenBox');
  searchBoxTimeline.to(nonSearchIcons, duration, { width: 0 }, 'widenBox');
  searchBoxTimeline.to(searchInput, 1, { width: '100%', opacity: 1 }, 'widenBox');
  searchBoxTimeline.to('.nav-icon', duration, { paddingLeft: 0, paddingRight: 0 }, 'widenBox');

  const closeSearchTimeLine = new TimelineLite();
  closeSearchTimeLine.to('.close-search', 0.25, { autoAlpha: 1 });
  searchBoxTimeline.add(closeSearchTimeLine);

  searchBoxTimeline.play();
  searchInput.focus();
}

// Animate search box
$('.search-box').click((e) => {
  if ($('.nav-bar').hasClass('mobile-nav-open')) {
    mobileSearchAnimation();
  } else {
    desktopSearchAnimation();
  }
});

function desktopCloseSearchAnimation() {
  const searchForm = $('form.search-box')
    .removeClass('search-box--open');
  const dropdown = $('.command-panel__drop');
  const searchBox = $('.search-box__input');
  const iconsHeight = $('.nav-icons').height();
  const labelHeight = $('.search-box__label').innerHeight();
  const searchIconRight = $('.search-box__icon').css('right');
  const dropdownWidth = dropdown.innerWidth();
  const reverseTimeLine = new TimelineLite({ paused: true });

  reverseTimeLine.add('start', 0);
  reverseTimeLine.add('shrinkBox', 0.25);
  reverseTimeLine.to(searchBox, 0.1, { opacity: 0 }, 'start');
  reverseTimeLine.to(searchBox, 0.5, { width: 0 }, 'shrinkBox');
  reverseTimeLine.to('.search-box__icon', 0.2, { right: 5 }, 'shrinkBox');
  reverseTimeLine.to('.search-box', 0.25, { paddingLeft: 0, paddingRight: 0 }, 'shrinkBox');
  reverseTimeLine.to(dropdown, 0.5, { width: dropdownWidth }, 'shrinkBox');
  reverseTimeLine.to(dropdown, 0.3, { borderColor: 'rgba(255,255,255,1)' }, 'shrinkBox');
  reverseTimeLine.to('.search-box', 0.25, { borderWidth: 1, borderColor: 'rgba(255,255,255,0)' });
  reverseTimeLine.call(() => { searchBoxTimeline.pause(0); });
  reverseTimeLine.set([searchBox, dropdown, '.search-box__icon', '.search-box', '.nav-icons', '.search-box__label', '.close-search'], { clearProps: 'all' });
  reverseTimeLine.play();
}

function mobileCloseSearchAnimation() {
  const dropdown = $('.command-panel__drop');
  const dropdownWidth = dropdown.innerWidth();
  const searchForm = $('form.search-box')
    .removeClass('search-box--open');
  const searchBox = searchForm.parent('.nav-icons__icon');
  const searchInput = $('.search-box__input');
  const nonSearchIcons = $('.nav-icons__icon').slice(1);
  const reverseTimeLine = new TimelineLite({ paused: true });
  reverseTimeLine.call(() => { searchBoxTimeline.pause(0); });
  reverseTimeLine.set([searchBox, searchInput, dropdown, '.search-box__icon', '.search-box', '.nav-icons', '.search-box__label', '.nav-icon-wrapper', '.nav-icon', '.close-search'], { clearProps: 'all' });
  reverseTimeLine.play();
}

$('.close-search').click((e) => {
  searchBoxTimeline.kill();
  if ($('.nav-bar').hasClass('mobile-nav-open')) {
    mobileCloseSearchAnimation();
  } else {
    desktopCloseSearchAnimation();
  }
});
